import { useCallback } from 'react';
import { ButtonLink } from 'shared/components/ButtonLink';
import { useRedirect } from 'shared/hooks/useRedirect';

export interface IButtonLinkContainerProps {
  children: string;
  onSendCa: VoidFunction;
}

export const ButtonLinkContainer: React.FC<IButtonLinkContainerProps> = ({ children, onSendCa }) => {
  const { redirect } = useRedirect();

  const handleClickButton = useCallback(() => {
    onSendCa();
    redirect();
  }, [onSendCa, redirect]);

  return <ButtonLink onClick={handleClickButton}>{children}</ButtonLink>;
};
